import React from "react";
import { useThemeContext } from "../../context/ThemeContext";
import { FaUniversity, FaUsers, FaBullhorn } from "react-icons/fa";
import DynamicHeader from "../DynamicComponents/DynamicHeader";

const ComingSoon = () => {
  const { darkMode } = useThemeContext();

  return (
    <div
      className="pb-4"
      style={{ backgroundColor: darkMode ? "#1E1E2E" : "#F8F8F8" }} // Darker black for dark mode
    >
      <DynamicHeader />
      <div
        className="min-h-screen flex flex-col items-center justify-center p-6"
        style={{
          backgroundColor: darkMode ? "#1E1E2E" : "#F8F8F8",
        }}
      >
        {/* Main Card */}
        <div
          className="rounded-2xl p-8 max-w-2xl w-full text-center"
          style={{
            backgroundColor: darkMode ? "#0D1117" : "#FFFFFF",
            border: darkMode ? "1px solid #252525" : "1px solid #E5E5E5",
            boxShadow: darkMode
              ? "0 4px 12px rgba(0, 0, 0, 0.5)"
              : "0 4px 12px rgba(0, 0, 0, 0.08)",
          }}
        >
          {/* Logo/Title */}
          <h1
            className="text-4xl font-bold mb-2"
            style={{ color: darkMode ? "#FFFFFF" : "#A41E22" }}
          >
            Coming Soon
          </h1>
          <p
            className="text-lg mb-6"
            style={{ color: darkMode ? "#B0B3B8" : "#666666" }}
          >
            The DTU ECE Platform
          </p>

          {/* Divider */}
          <div
            className="h-px w-24 mx-auto my-6"
            style={{ backgroundColor: "#A41E22" }}
          ></div>

          <p
            className="text-xl mb-8 max-w-lg mx-auto"
            style={{ color: darkMode ? "#B0B3B8" : "#666666" }}
          >
            We're building something special for the ECE community. Stay tuned!
          </p>

          {/* Feature Icons */}
          <div className="flex justify-center space-x-8 mb-8">
            <div className="text-center">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-2"
                style={{ backgroundColor: "rgba(164, 30, 34, 0.1)" }}
              >
                <FaUniversity
                  className="text-2xl"
                  style={{ color: "#A41E22" }}
                />
              </div>
              <p style={{ color: darkMode ? "#B0B3B8" : "#666666" }}>
                Community
              </p>
            </div>
            <div className="text-center">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-2"
                style={{ backgroundColor: "rgba(164, 30, 34, 0.1)" }}
              >
                <FaUsers className="text-2xl" style={{ color: "#A41E22" }} />
              </div>
              <p style={{ color: darkMode ? "#B0B3B8" : "#666666" }}>Connect</p>
            </div>
            <div className="text-center">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-2"
                style={{ backgroundColor: "rgba(164, 30, 34, 0.1)" }}
              >
                <FaBullhorn className="text-2xl" style={{ color: "#A41E22" }} />
              </div>
              <p style={{ color: darkMode ? "#B0B3B8" : "#666666" }}>Engage</p>
            </div>
          </div>

          {/* Footer Note */}
          <p
            className="text-sm mt-8"
            style={{ color: darkMode ? "#B0B3B8" : "#888888" }}
          >
            © {new Date().getFullYear()} DTU ECE Department
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
